<template>
  <v-dialog v-model="modal_folder" width="500">
    <v-card>
      <v-card-title class="primary py-2 pr-2">
        <div class="d-flex justify-space-between align-center w-full white--text">
          <div>
            <v-icon class="mr-2" color="white">mdi-link-variant</v-icon>
            {{ $store.state.form_folder.id ? "Update" : "Create" }} Folder
          </div>
          <v-btn icon>
            <v-icon @click="modal_folder = false">mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <div class="pa-2">
        <v-text-field
          label="Folder Name"
          outlined
          hide-details
          clearable
          autofocus
          v-model.trim="form_folder_name"
          @keyup.enter="clickSubmit"
          ref="input"
          class="mb-3 mt-6"
          prepend-inner-icon="mdi-format-title"
          tabindex="1"
        ></v-text-field>

        <v-textarea
          class="mt-6"
          outlined
          label="Note"
          v-model="form_folder_note"
          auto-grow
          no-resize
          rows="1"
          clearable
          prepend-inner-icon="mdi-note-outline"
          tabindex="2"
          @keyup.ctrl.enter="$store.dispatch('submitUrl')"
        ></v-textarea>

        <ParentSelector v-model="form_folder_location" tabindex="3" />

        <div class="d-flex justify-end align-center mt-5">
          <v-switch
            v-model="form_folder_hidden"
            label="Hidden"
            hide-details
            class="ma-0"
            :disabled="!ifUnlockCode"
          ></v-switch>
          <v-menu
            v-model="info_hidden"
            offset-y
            :close-on-content-click="false"
            :close-on-click="true"
            :nudge-left="150"
            :nudge-bottom="10"
            :max-width="300"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon size="20" color="primary" v-bind="attrs" v-on="on" class="ml-5 mt-2">
                mdi-information-outline
              </v-icon>
            </template>

            <v-card>
              <v-card-text>
                <p>
                  When you make a folder hidden, all it's contents will be hidden on the screen for
                  the wondering eyes behind your back. You can unlock all hidden folders temporarily
                  using the unlock button (<v-icon>mdi-lock-outline</v-icon>) on the menu bar.
                </p>

                <div v-if="!ifUnlockCode">
                  <p>You need to set a 4-digit unlock code before using this feature.</p>

                  <div class="text-center">
                    <v-btn
                      class="mt-5"
                      dense
                      color="primary"
                      outlined
                      @click="$store.commit('updateStateLock', { modal: true })"
                    >
                      CLICK TO SET 4-DIGIT CODE
                    </v-btn>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-menu>
        </div>

        <v-btn
          block
          x-large
          color="primary"
          class="mt-10"
          @click="clickSubmit"
          tabindex="4"
          outlined
        >
          save FOLDER
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import ParentSelector from "./ParentSelector";
export default {
  name: "ModalFolder",
  components: { ParentSelector },
  data() {
    return {
      info_hidden: false,
    };
  },
  computed: {
    modal_folder: {
      get() {
        return this.$store.state.form_folder.modal;
      },
      set(value) {
        this.$store.commit("updateStateFormFolder", { modal: value });
      },
    },
    form_folder_name: {
      get() {
        return this.$store.state.form_folder.name;
      },
      set(value) {
        this.$store.commit("updateStateFormFolder", { name: value });
      },
    },
    form_folder_note: {
      get() {
        return this.$store.state.form_folder.note;
      },
      set(value) {
        this.$store.commit("updateStateFormFolder", { note: value });
      },
    },
    form_folder_location: {
      get() {
        return this.$store.state.form_folder.location;
      },
      set(value) {
        console.log("here");
        this.$store.commit("updateStateFormFolder", { location: value });
      },
    },
    form_folder_hidden: {
      get() {
        return this.$store.state.form_folder.hidden;
      },
      set(value) {
        this.$store.commit("updateStateFormFolder", { hidden: value });
      },
    },
    form_folder_id() {
      return this.$store.state.form_folder.id;
    },
    ifUnlockCode() {
      return !!this.$store.state.user.unlockCode;
    },
  },
  methods: {
    clickSubmit() {
      this.$store.dispatch("submitFolder");
    },
  },
};
</script>
